export default "__VITE_ASSET__BdB421lS__"